import React from 'react';
import moment from 'moment-timezone';
import List, { ListItem, ListItemText } from 'material-ui/List';
import PropTypes from 'prop-types';

const quickViews = timezone => [
  {
    queryParams: {
      from: moment()
        .subtract(5, 'minutes')
        .unix(),
      to: moment().unix(),
      aggregationLevel: false
    },
    text: 'Last 5 Minutes',
    chartType: 'charts'
  },
  {
    queryParams: {
      from: moment()
        .subtract(1, 'hour')
        .unix(),
      to: moment().unix(),
      aggregationLevel: false
    },
    text: 'Last Hour',
    chartType: 'charts'
  },
  {
    queryParams: {
      from: moment()
        .startOf('hour')
        .subtract(1, 'hour')
        .unix(),
      to: moment()
        .startOf('hour')
        .unix(),
      aggregationLevel: false
    },
    text: 'Last Full-Hour',
    chartType: 'charts'
  },
  {
    queryParams: {
      from: moment()
        .subtract(1, 'day')
        .unix(),
      to: moment().unix(),
      aggregationLevel: false
    },
    text: 'Last 24 Hours',
    chartType: 'charts'
  },
  {
    queryParams: {
      from: moment()
        .startOf('day')
        .subtract(1, 'day')
        .unix(),
      to: moment()
        .startOf('day')
        .unix(),
      aggregationLevel: false
    },
    chartType: 'charts',
    text: 'Yesterday'
  },
  {
    queryParams: {
      from: moment()
        .startOf('day')
        .subtract(7, 'days')
        .unix(),
      to: moment()
        .startOf('day')
        .unix(),
      aggregationLevel: false
    },
    text: 'Last Week'
  },
  {
    queryParams: {
      from: moment()
        .startOf('day')
        .subtract(14, 'days')
        .unix(),
      to: moment()
        .startOf('day')
        .unix(),
      aggregationLevel: false
    },
    text: 'Last 2 Week'
  },
  {
    queryParams: {
      from: moment()
        .startOf('day')
        .subtract(30, 'days')
        .unix(),
      to: moment()
        .startOf('day')
        .unix(),
      aggregationLevel: false
    },
    text: 'Last 30 Days'
  },
  {
    queryParams: {
      from: moment()
        .startOf('month')
        .subtract(1, 'month')
        .unix(),
      to: moment()
        .startOf('month')
        .unix(),
      aggregationLevel: false
    },
    text: 'Last Month'
  }
];

const NavSamplesQuickViews = ({
  pageType,
  updateQueryParams,
  timezone,
  loading
}) => (
  <List>
    {quickViews(timezone).map((view, index) => {
      if (pageType === 'sankey' && view.chartType === 'charts') {
        return null;
      }

      if (pageType === 'sankey') {
        view.queryParams.aggregationLevel = 'days_1';
      }

      return (
        <ListItem
          key={index}
          button
          onClick={() => updateQueryParams({ ...view.queryParams })}
          disabled={loading}
        >
          <ListItemText primary={view.text} />
        </ListItem>
      );
    })}
  </List>
);

NavSamplesQuickViews.propTypes = {
  pageType: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
  updateQueryParams: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default NavSamplesQuickViews;



// WEBPACK FOOTER //
// ./src/components/nav/NavSamplesQuickViews.js